import React, { useEffect } from 'react';
import {
  Anchor,
  DraggableGroup,
  DraggableList,
  DraggableListGroupPlaceholder,
  Inscription,
  Preloader,
  Text,
} from '@common-fe/common-fe';
import _ from 'lodash';

import ROUTES from '@/common/routes';
import LockboxInfoContainer from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxInfoContainer';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { useLockboxDividingModeStore } from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDividingMode.store';

const LockboxDividedRecords = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const { groups, setGroups } = useLockboxDividingModeStore();

  useEffect(() => {
    if (!originalLockbox?.childRecords?.length) {
      return;
    }

    const sortedChildRecords = _.sortBy(originalLockbox?.childRecords, item => item.main !== true);

    const newGroups: DraggableGroup[] = sortedChildRecords?.map((childRecord) => ({
      key: childRecord?.id || '',
      title: (
        <Text>
          <Anchor
            href={ROUTES.LOCKBOX_DETAILS(childRecord?.id)}
            target="_blank"
            weight={700}
            style={{ outline: 'none'}}
          >
            {childRecord?.name}
          </Anchor>
          {childRecord?.main && ' (Main)'}
        </Text>
      ),
      items: childRecord?.pages?.map((page) => ({
        key: `${page}`,
        node: <Preloader />,
      })) || [],
    }));

    setGroups(newGroups);
  }, [originalLockbox?.childRecords, setGroups]);

  return (
    <LockboxInfoContainer margin={{ top: 'spacing12' }}>
      <Inscription color="textSecondary" margin={{ bottom: 'spacing12' }}>
        Divided records
      </Inscription>

      <DraggableList
        testId="divided-records"
        groups={groups}
        placeholder={<DraggableListGroupPlaceholder placeholderText="Divided pages" />}
      />
    </LockboxInfoContainer>
  );
};

export default LockboxDividedRecords;
